import { cn } from '@cardo/lib';
import { Turnstile as CFTurnstile } from '@marsidev/react-turnstile';
import { ClientOnly } from 'remix-utils/client-only';

export function Turnstile({
  siteKey,
  className,
}: {
  siteKey: string;
  className?: string;
}) {
  return (
    <ClientOnly fallback={<div />}>
      {() => (
        <CFTurnstile
          siteKey={siteKey}
          options={{
            size: 'flexible',
            theme: 'light',
          }}
          style={{
            height: '100%',
            maxHeight: '65px',
          }}
          className={cn(className)}
        />
      )}
    </ClientOnly>
  );
}
